import { MdPlace } from '@react-icons/all-files/md/MdPlace';
import { MdGavel } from '@react-icons/all-files/md/MdGavel';
import { MdWork } from '@react-icons/all-files/md/MdWork';
import { MdEventNote } from '@react-icons/all-files/md/MdEventNote';
import React from 'react';
import cn from 'classnames';
import { MdLocationCity } from '@react-icons/all-files/md/MdLocationCity';

const JobDetailRow = ({ data, dark = false, spread = false }) => {
  return <div
    className={cn('flex flex-col space-y-1 lg:space-y-0 lg:flex-row italic', {
      'lg:space-x-4 xl:space-x-8': spread,
      'lg:space-x-4': !spread
    })}>
    <div className='flex space-x-1 items-center'>
      <MdLocationCity className={cn('w-6 h-6', { 'text-primary': !dark, 'text-black': dark })} />
      <p>{data.type}</p>
    </div>
    <div className='flex space-x-1 items-center'>
      <MdPlace className={cn('w-6 h-6', { 'text-primary': !dark, 'text-black': dark })} />
      <p>{data.area}</p>
    </div>
    <div className='flex space-x-1 items-center whitespace-nowrap'>
      <MdGavel className={cn('w-6 h-6', { 'text-primary': !dark, 'text-black': dark })} />
      <p>T-{data.minPeriod}+</p>
    </div>
    <div className='flex space-x-1 items-center'>
      <MdWork className={cn('w-6 h-6', { 'text-primary': !dark, 'text-black': dark })} />
      <p>{data.industry}</p>
    </div>
    <div className='flex space-x-1 items-center'>
      <MdEventNote className={cn('w-6 h-6', { 'text-primary': !dark, 'text-black': dark })} />
      <p>Sista ansökningsdag - {data.lastApplicationDate.substr(0, 10)}</p>
    </div>
  </div>;
};

export default JobDetailRow;